define("shared/components/shared/upgrade/mobile-plan-card", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _component2, _object, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@glimmer/tracking",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    
  <Shared::Ui::Button
    data-test-id="button"
    class="o--card tPF--plan__card tPF--plan__item--{{@plan.planType}} {{this.selectionClass}}"
    @type="outline"
    @size="large"
    @additional="block"
    @text={{t "authorization.sign_up_trial.button_yes"}}
    {{on "click" (fn @selectPlan @plan.planType)}}
  >
    <div class="tPF--plan__cardSectionTitle">
      <h2 class="tPF--plan__title">{{t (concat "plans.plan_names." @plan.planType)}}</h2>
      <div class="tPF--plan__price tPF--plan__note">
        <span class="u--m__r__xs u--text--lg u--text--strike"><b>{{t "plans.currency_symbol"}}{{div @plan.monthlyPrice 100}}</b>{{t "plans.per_month"}}</span>
        {{svg-jar this.icon class="o--icon o--icon--lg tPF--plan__priceIcon"}}
      </div>
    </div>
    <div class="u--m__b__md">
      <p class="u--text--md">{{t (concat "authorization.sign_up_trial." @plan.planType ".description")}}</p>
      <ul class="u--m__0 u--p__0 tPF--plan__cardList">
        {{#each @plan.trialOptInHighlights.mobile.includes as |highlight|}}
          <li class="tPF--plan__cardListBullet u--text--base u--text--bold">
            {{highlight}}
          </li>
        {{/each}}
      </ul>
    </div>
    <div class="tPF--plan__meta">
      <Shared::Ui::Button
        class="tPF--plan__link u--p__0 u--text--uppercase u--text--md"
        @type="unstyled"
        {{track "expanded-trial-offer" "click" plan=@plan.planType}}
        {{on "click" this.openShowAllFeaturesModal}}
      >
        {{svg-jar "info" class="o--icon tPF--plan__icon"}}
        {{t "authorization.sign_up_trial.plan_details_link" planName=@plan.name}}
      </Shared::Ui::Button>
    </div>
  </Shared::Ui::Button>
  
  {{#if this.showAllFeaturesModal}}
    <Shared::Upgrade::AllFeaturesModal
      @plan={{@plan}}
      @isMonthly={{this.currentSubscriptionPlan.isMonthly}}
      @close={{toggle-action "showAllFeaturesModal" this}}
    />
  {{/if}}
  
  */
  {
    "id": "dP+gLB23",
    "block": "[[[1,\"\\n\"],[8,[39,0],[[24,\"data-test-id\",\"button\"],[16,0,[29,[\"o--card tPF--plan__card tPF--plan__item--\",[30,1,[\"planType\"]],\" \",[30,0,[\"selectionClass\"]]]]],[4,[38,2],[\"click\",[28,[37,3],[[30,2],[30,1,[\"planType\"]]],null]],null]],[[\"@type\",\"@size\",\"@additional\",\"@text\"],[\"outline\",\"large\",\"block\",[28,[37,1],[\"authorization.sign_up_trial.button_yes\"],null]]],[[\"default\"],[[[[1,\"\\n  \"],[10,0],[14,0,\"tPF--plan__cardSectionTitle\"],[12],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"tPF--plan__title\"],[12],[1,[28,[35,1],[[28,[37,4],[\"plans.plan_names.\",[30,1,[\"planType\"]]],null]],null]],[13],[1,\"\\n    \"],[10,0],[14,0,\"tPF--plan__price tPF--plan__note\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--m__r__xs u--text--lg u--text--strike\"],[12],[10,\"b\"],[12],[1,[28,[35,1],[\"plans.currency_symbol\"],null]],[1,[28,[35,5],[[30,1,[\"monthlyPrice\"]],100],null]],[13],[1,[28,[35,1],[\"plans.per_month\"],null]],[13],[1,\"\\n      \"],[1,[28,[35,6],[[30,0,[\"icon\"]]],[[\"class\"],[\"o--icon o--icon--lg tPF--plan__priceIcon\"]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--m__b__md\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md\"],[12],[1,[28,[35,1],[[28,[37,4],[\"authorization.sign_up_trial.\",[30,1,[\"planType\"]],\".description\"],null]],null]],[13],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"u--m__0 u--p__0 tPF--plan__cardList\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,1,[\"trialOptInHighlights\",\"mobile\",\"includes\"]]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[14,0,\"tPF--plan__cardListBullet u--text--base u--text--bold\"],[12],[1,\"\\n          \"],[1,[30,3]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[3]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"tPF--plan__meta\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,0,\"tPF--plan__link u--p__0 u--text--uppercase u--text--md\"],[4,[38,9],[\"expanded-trial-offer\",\"click\"],[[\"plan\"],[[30,1,[\"planType\"]]]]],[4,[38,2],[\"click\",[30,0,[\"openShowAllFeaturesModal\"]]],null]],[[\"@type\"],[\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,6],[\"info\"],[[\"class\"],[\"o--icon tPF--plan__icon\"]]]],[1,\"\\n      \"],[1,[28,[35,1],[\"authorization.sign_up_trial.plan_details_link\"],[[\"planName\"],[[30,1,[\"name\"]]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"  \"],[8,[39,11],null,[[\"@plan\",\"@isMonthly\",\"@close\"],[[30,1],[30,0,[\"currentSubscriptionPlan\",\"isMonthly\"]],[28,[37,12],[\"showAllFeaturesModal\",[30,0]],null]]],null],[1,\"\\n\"]],[]],null]],[\"@plan\",\"@selectPlan\",\"highlight\"],false,[\"shared/ui/button\",\"t\",\"on\",\"fn\",\"concat\",\"div\",\"svg-jar\",\"each\",\"-track-array\",\"track\",\"if\",\"shared/upgrade/all-features-modal\",\"toggle-action\"]]",
    "moduleName": "shared/components/shared/upgrade/mobile-plan-card.hbs",
    "isStrictMode": false
  });

  let MobilePlanCardComponent = (_class = class MobilePlanCardComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "showAllFeaturesModal", _descriptor, this);
    }

    get selectionClass() {
      if (!this.args.selectedPlan) {
        return '';
      }

      return this.args.selectedPlan === this.args.plan.planType ? 'is--selected' : 'is--unselected';
    }

    get icon() {
      return this.isSelected ? 'verified-solid' : 'verified';
    }

    openShowAllFeaturesModal(event) {
      event.stopPropagation();
      this.showAllFeaturesModal = true;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "showAllFeaturesModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "openShowAllFeaturesModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openShowAllFeaturesModal"), _class.prototype)), _class);
  _exports.default = MobilePlanCardComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MobilePlanCardComponent);
});